export default "__VITE_ASSET__HLolZNSM__"